import angular from 'angular'
import { apiKeyTypes } from '../api-keys'

export function OrganizationAPIKeyCtrl(
  $scope,
  ProfileService,
  permissions,
  apiAuthorizationService,
  rotateKeyModalService,
  keysManagementService,
  keyStatusService,
  logger
) {
  'ngInject'

  angular.extend($scope, {
    model: {
      apiKeyData: apiAuthorizationService.getInitialData()
    },
    apiKeyStatus: {
      rotated: false
    }
  })

  angular.extend($scope, {
    rotateAPIKey
  })

  init()

  function init() {
    $scope.model.userID = ProfileService.getUid()
    if (!permissions.isImpersonating()) {
      _getApiKeyData()
    }
  }

  function _getApiKeyData() {
    return apiAuthorizationService.init().then(({ apiKey }) => {
      $scope.model.apiKeyData.apiKey = apiKey
    })
  }

  function rotateAPIKey() {
    rotateKeyModalService.openRotateKeyModal(apiKeyTypes.API_KEY).then(() => {
      return _rotateAPIKeyAndLogSuccess()
    })
  }

  function _rotateAPIKeyAndLogSuccess() {
    return keysManagementService.rotateAPIKey().then((response) => {
      logger.logSuccess(response.messages[0], { timeOut: 3500 })
      return _updateApiKeyStatus()
    })
  }

  function _updateApiKeyStatus() {
    return _getApiKeyData().then(() => {
      keyStatusService.changeKeyStatusToRotated($scope.apiKeyStatus)
    })
  }
}
